import { render, staticRenderFns } from "./DataViewSidebar.vue?vue&type=template&id=3665a58a&scoped=true&"
import script from "./DataViewSidebar.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebar.vue?vue&type=style&index=0&id=3665a58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665a58a",
  null
  
)

export default component.exports